import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const templateCharCountStyle = css`
  border-top: solid 1px ${theme.colors.neutral20};
  padding-top: ${theme.spacing(1)};
  margin-top: ${theme.spacing(1)};
  text-align: right;
  margin-bottom: ${theme.spacing(-1)};
`;
